// extracted by mini-css-extract-plugin
export default {"Title":"ForbiddenView_Title__AkolC","ForbiddenView":"ForbiddenView_ForbiddenView__U7CZs"};